/* global WebView, ViewController */


var dbadminController = new ViewController({
    directory : "views/dbadmin",
    name: "dbadmin",
    container: "main",
    route: "dbadmin"
}) ;

dbadminController.prepareDataOnEnter = function(data, callback){
    callback(null, {
        databases: []
    }) ;
} ;

dbadminController.onListDatabases = function(){
    var v = new WebView("views/dbadmin",  "adminPasswordPopup") ;
    v.openInPopup();
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        var data = v.getData() ;
        v.longTask(function(done){
            this.api.dbadmin.getDatabaseList(data.password, function(err, databases){
                if(err){ return done(err) ;}
                v.close() ;
                this.data.databases = databases ;
                this.view.render() ;
                done() ;

            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dbadminController.onRestore = function(){
    var v = new WebView("views/dbadmin",  "restoreDbPopup") ;
    v.openInPopup();
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        v.checkForm(function(err, formOk){
            if(err || !formOk){
                return;
            }
            if(v.EL.customFile.files.length === 0){
                return v.error(v.tr("util.pleaseSelectAFile")) ;
            }

            var data = v.getData() ;

            if(/[^a-z0-9_]/.test(data.dbName)){
                return v.error(v.tr("dbadmin.dbNameShouldBeLowerDigit")) ;
            }

            var file = v.EL.customFile.files[0] ;
            v.longTask(function(done){
                this.api.dbadmin.restoreDatabase(data.password, data.dbName, file, function(err){
                    if(err){ return done(err) ;}
                    this.api.dbadmin.getDatabaseList(data.password, function(err, databases){
                        if(err){ return done(err) ;}
                        v.close() ;
                        this.data.databases = databases ;
                        this.view.render() ;
                        done() ;

                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dbadminController.onBackup = function(ev){
    var db = ev.data.data ;
    var v = new WebView("views/dbadmin",  "adminPasswordPopup") ;
    v.openInPopup();
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        var data = v.getData() ;
        v.close() ;
        this.api.dbadmin.backupDatabase(data.password, db.dbName, function(err){
            if(err){ return console.log(err) ;}
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dbadminController.onDelete = function(ev){
    var db = JSON.parse(JSON.stringify(ev.data.data)) ;
    var v = new WebView("views/dbadmin",  "confirmDeletePopup") ;
    v.openInPopup(function(){
        v.render(db) ;
    });
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        var data = v.updateData() ;
        v.longTask(function(done){
            this.api.dbadmin.deleteDatabase(data.password, db.dbName, function(err){
                if(err){ return done(err) ;}
                this.api.dbadmin.getDatabaseList(data.password, function(err, databases){
                    if(err){ return done(err) ;}
                    v.close() ;
                    this.data.databases = databases ;
                    this.view.render() ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dbadminController.onCopy = function(ev){
    var db = JSON.parse(JSON.stringify(ev.data.data)) ;
    var v = new WebView("views/dbadmin",  "copyDbPopup") ;
    v.openInPopup(function(){
        v.render(db) ;
    });
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        v.checkForm(function(err, formOk){
            if(err || !formOk){
                return;
            }
            var data = v.getData() ;

            if(/[^a-z0-9_]/.test(data.dbNameNew)){
                return v.error(v.tr("dbadmin.dbNameShouldBeLowerDigit")) ;
            }
            v.longTask(function(done){
                this.api.dbadmin.duplicateDatabase(data.password, db.dbName, data.dbNameNew, function(err){
                    if(err){ return done(err) ;}
                    this.api.dbadmin.getDatabaseList(data.password, function(err, databases){
                        if(err){ return done(err) ;}
                        v.close() ;
                        this.data.databases = databases ;
                        this.view.render() ;
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dbadminController.onChangeModule = function(ev){
    var selectedDb = ev.data.data ;
    var db = JSON.parse(JSON.stringify(ev.data.data)) ;
    db.modules = db.modules.map(function(m){ return m.name ; }) ;
    db.showPassword = true ;
    var v = new WebView("views/dbadmin",  "addModulePopup") ;
    v.openInPopup(function(){
        v.render(db) ;
    });
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        var data = v.updateData() ;
        v.longTask(function(done){
            this.api.dbadmin.updateDatabaseModules(data.password, data.dbName, data.modules, function(err, modules){
                if(err){ return done(err) ;}
                v.close() ;
                selectedDb.modules = modules ;
                this.view.render() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

dbadminController.onCreate = function(){
    var v = new WebView("views/dbadmin",  "createDbPopup") ;
    
    v.on("cancel", function(){ v.close() ;}) ;
        
    v.openInPopup();
    v.on("validate", function(){
        v.checkForm(function(err, formOk){
            if(err || !formOk){
                return;
            }
            if(v.EL.customFile.files.length === 0){
                return v.error(v.tr("util.pleaseSelectAFile")) ;
            }

            var data = v.getData() ;

            if(/[^a-z0-9_]/.test(data.dbName)){
                return v.error(v.tr("dbadmin.dbNameShouldBeLowerDigit")) ;
            }

            var file = v.EL.customFile.files[0] ;
    
            v.longTask(function(done){
                this.api.dbadmin.createDatabase(data.password, data.dbName, data.name, JSON.stringify(data.modules), file, function(err, adminPassword){
                    if(err){ return done(err) ;}
                    done() ;

                    var vDisplay = new WebView("views/dbadmin",  "displayPasswordPopup") ;
                    vDisplay.openInPopup({
                        closeWithEsc: false
                    }, function(){
                        vDisplay.render({
                            password: adminPassword
                        }) ;
                    });

                    vDisplay.on("close", function(){
                        v.close() ;
                    }.bind(this));
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = dbadminController ;